if (top.location.origin !== self.location.origin) {
  parent.location = self.location
}
